import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getProCloseDetail } from '@/service/production/proReportAggregate';
export default function useCloseList() {
  var formatDate = function formatDate(date) {
    return dayjs(date).format('YYYY-MM-DD');
  };
  var proCloseList = ref([]);
  var proCloseListParams = ref({
    areaId: '',
    startTime: formatDate() + ' 00:00:00',
    endTime: formatDate() + ' 23:59:59',
    deviceKey: '',
    deviceName: ''
  });
  // 查询时间范围内停机详情
  var getProCloseListAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getProCloseDetail(proCloseListParams.value);
          case 2:
            data = _context.sent;
            proCloseList.value = data.list;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getProCloseListAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [proCloseListParams, proCloseList, getProCloseListAsync];
}